export enum actionTypesOperations {
  ListOfOperations = "operationsList",
  LoadingFilterOperations = "LoadingFilterOperations",
  FilterOperations = "filteredOperationsList",
  SearchOperations = "searchOperationsList",
  IsOperationsTableRefreshed = "IsOperationsTableRefreshed",
  SelectedOperation = "selectedOperation",
  ListOfOperationUsers = "operationUsers",
  OperationAttachmentsList = "operationAttachmentsList",
  OperationHistoryList = "operationHistoryList",
  UpdateOperationAuditSort = "updateOperationAuditSort",
  UpdateOperationAuditPage = "updateOperationAuditPage",
  UpdateOperationAuditPageSize = "updateOperationAuditPageSize",
}
